import React from 'react'
import { TextField } from 'ic-snacks'
import Dropdown from 'legacy/components/Dropdown'
import { type DropdownOption, Permission } from 'legacy/common/types'
import useAccessControl from 'legacy/components/AccessControl/useAccessControl'
import { type ProductFormValues } from 'legacy/routes/catalog/types/product.types'

interface Props {
  values: ProductFormValues
  brands: DropdownOption[]
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  setFieldValue: (name: string, value: number) => void
}

function ProductBrand(props: Props) {
  const {
    values: { brand_id, editable, is_private_label, brand_name },
    brands,
    onChange,
    setFieldValue,
  } = props

  const hasAccess = useAccessControl()
  const canEditBrand = hasAccess({ permissions: Permission.AdminEditBrand })

  // If editable but not retailer owned, we allow the user to edit brand as free text,
  // because the brand won't appear in their pre-defined list of brands.
  // IC Admins have permission to edit brand, so we allow full editability of this field.
  if ((editable && !is_private_label) || canEditBrand) {
    return (
      <TextField
        name="brand_name"
        value={brand_name}
        floatingLabelText="Brand Name"
        fullWidth
        onChange={onChange}
      />
    )
  }

  // If editable and owned, we know the brand exists
  // in their warehouse brands, so edit as a select option.
  if (editable && is_private_label) {
    return (
      <Dropdown
        margin="0"
        value={brand_id}
        options={brands}
        onChange={(value: number) => setFieldValue('brand_id', value)}
      />
    )
  }

  // If not editable, read only.
  return (
    <TextField name="brand_name" value={brand_name} disabled floatingLabelText="Brand" fullWidth />
  )
}

export default ProductBrand
